import moment from 'moment';
import CryptoJS from 'crypto-js';
import * as jose from 'jose'
import { switchCase, switchStatement } from '@babel/types';
import { IconTypes, RenderIcons } from '../components/controls/icons';
import { FileAccessibilityMapping } from './constants';

export const convertBytestoMb = (bytes, format) => {
  switch (format) {
    case "MB":
      return `${((bytes / 1024) / 1024).toFixed(3)} ${format}`;

    case "KB":
      return `${(bytes / 1024).toFixed(3)} ${format}`;

    default: return `${bytes}bytes`
  }

}

export const convertDate = (date, format) => {
  const val = moment(date).format(format);
  return val;
}

export const reqBody = (sortBy, orderBy) => {
  const body = {
    filter: {
      fileName: ''
    },
    pageInfo: {
      pageSize: 100,
      pageNumber: 1
    },
    sortBy: sortBy,
    orderBy: orderBy ? 1 : -1
  }
  return body
}

export function renderFileIconClass(_fileExt) {
  const fileExt = (_fileExt || "").toString().toLowerCase()
  let _class = "";
  if (fileExt == "doc") {
    _class = "iconDoc";
  } else if (fileExt == "docx") {
    _class = "iconDocx";
  } else if (fileExt == "pdf") {
    _class = "iconPdf";
  } else if (fileExt == "ppt") {
    _class = "iconPpt";
  } else if (fileExt == "pptx") {
    _class = "iconPptx";
  } else if (fileExt == "xls") {
    _class = "iconXls";
  } else if (fileExt == "xlsx") {
    _class = "iconXslx";
  } else if (fileExt == "txt") {
    _class = "iconTxt";
  }
  else if (["jpeg", "jpg", "png", "svg", "gif", "bmp", "tiff"].includes(fileExt)) {
    _class = "iconImages";
  }
  else if (["mp3", "mp4", "avi", "mkv", "mov", "wmv", "flv", "webm"].includes(fileExt)) {
    _class = "iconVideos";
  } 
  else if (["zip", "zipx", "tar", "gz", "rar", "7z"].includes(fileExt)) {
    _class = "iconZip";
  }
  else {
    _class = "iconFallback";
  }
  _class = "doc-repo-icon " + _class;
  return _class;
}

export function renderSourceTypeIconClass(sourceType) {
  const type = (sourceType || '').toLowerCase()
  const dict = {
      portal: 'Portal',
      onedrive: 'OneDrive',
      azure: 'Azure',
      rssfeed: 'Rss',
      aws: 'Aws',
      network: 'Network',
      gcp: 'Gcp'
  }
 return "slb_file_sourceType slb_file_sourceType_icon_" + (dict[type] ? dict[type] : 'noIcon');
}

export function ReadObjectProp(fieldPath, obj) {
  if (typeof obj === 'object' && typeof fieldPath === 'string')
    return fieldPath.split('.').reduce((p, c) => p && p[c] || null, obj)
  return null;
}


export const ResourceDataVariableName = "KRM_data_resource_";


export function getConfiguredLabel(page, label) {
  let labelText = null;
  if (window[ResourceDataVariableName] != undefined) {
    const appResource = window[ResourceDataVariableName];
    labelText = appResource && appResource[page] && appResource[page][label];
  }
  return labelText ? labelText : "";
}

export function GetSafeJsx(jsx) {
  if (jsx?.$$typeof?.toString() === 'Symbol(react.element)')
    return jsx;
  return null;
}

export function GetMillisecondsToTime(ms) {
  var d = new Date(1000 * Math.round(ms / 1000)); // round to nearest second
  function pad(i) { return ('0' + i).slice(-2); }
  return {
    hour: d.getUTCHours(),
    min: pad(d.getUTCMinutes()),
    sec: pad(d.getUTCSeconds())
  }
}

export function getJsonFromString(_string) {
  let json = {}
  try { json = JSON.parse(_string) } catch (error) { }
  return json;
}


export function decodeFromBase64String(base64String) {
  return Buffer.from(base64String, "base64").toString("utf8");
}

export function jsonFromBase64(base64String) {
  const jsonString = atob(base64String);
  
  let result;
  try { result = JSON.parse(jsonString); } catch (error) { }
  console.log(result)
  return result || {}
}

export function convertStringToTitleCase(str) {
  if(str==null) return ''
  
  var splitStr = str.toLowerCase().split(' ');
  for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
  }
  return splitStr.join(' '); 
}

export const months = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];

//CLIENT SIDE ENCRYPTING FUNCTIONS
export function encryptData(clientData){
  var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(clientData), 'privateEncryptionKey').toString();
  return encryptedData
}


export function encryptPayloadObject(plainObject){
  let encryptedPayload = {}
  for (const key in plainObject) {
      if (plainObject.hasOwnProperty(key)) {
          const plainValue = plainObject[key];
          const encryptedValue = encryptData(plainValue);
          encryptedPayload[key] = encryptedValue;
      }
  }
  return encryptedPayload
}

export const encryptObject = async function (data,key) {
  try {
    const publicCryptoKey = await jose.importSPKI(key, 'RSA-OAEP-256');

    const encryptedData = await new jose.CompactEncrypt(new TextEncoder().encode(JSON.stringify(data)))
      .setProtectedHeader({ alg: "RSA-OAEP-256", enc: "A256GCM" })
      .encrypt(publicCryptoKey);

    return encryptedData
  }
  catch (e) {
    //console.log(e);
  }
}

export function renderGroupIcon(fileAccessibility) {
  switch(fileAccessibility){
    case FileAccessibilityMapping.private:
      return RenderIcons(IconTypes.PrivateIcon)
    case FileAccessibilityMapping.group:
      return RenderIcons(IconTypes.GroupIcon)
    default:
      return RenderIcons(IconTypes.PublicIcon)
  }
}

export const emailRegex = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
export const emailRegex_evalue = /^[A-Z0-9._%+-]+@evalueserve.com$/i;